import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const PromiseCard = () => (
  <aside className='hcp-promise-card' aria-labelledby='hcp-promise-heading'>
    <div className='hcp-promise-card__label'>What happens with this submission</div>
    <h2 id='hcp-promise-heading' className='hcp-promise-card__heading'>
      You submit. We review. The patient hears from us only if they&apos;re eligible.
    </h2>
    <ol className='hcp-promise-card__list'>
      <li className='hcp-promise-card__item'>
        <span className='hcp-promise-card__step-number' aria-hidden='true'>
          1
        </span>
        <span className='hcp-promise-card__text'>
          <strong>You submit</strong> the patient&apos;s email and report PDF.
        </span>
      </li>
      <li className='hcp-promise-card__item'>
        <span className='hcp-promise-card__step-number' aria-hidden='true'>
          2
        </span>
        <span className='hcp-promise-card__text'>
          <strong>Our curation team reviews</strong> internally; typically in 3-5 business days.
        </span>
      </li>
      <li className='hcp-promise-card__item'>
        <span className='hcp-promise-card__step-number' aria-hidden='true'>
          3
        </span>
        <span className='hcp-promise-card__text'>
          <strong>If eligible</strong> we contact the patient directly. They opt in before any tests.
        </span>
      </li>
    </ol>
    <div className='hcp-promise-card__footer'>
      <FontAwesomeIcon icon={faArrowDown} className='hcp-promise-card__footer-icon' aria-hidden='true' />
      <span className='hcp-promise-card__footer-text'>Full timeline below the form.</span>
    </div>
  </aside>
);
